import { cn } from '@/components/ui/utils';

interface EmptyStateProps {
  title: string;
  body: string;
  className?: string;
  action?: React.ReactNode;
}

export function InternEmptyState({ title, body, className, action }: EmptyStateProps) {
  return (
    <div className={cn(
      'flex flex-col items-center justify-center py-12 px-6 text-center',
      'rounded-[4px] border border-dashed border-[var(--border)]',
      className
    )}>
      {/* Gold spark */}
      <span className="text-[var(--color-gold)] text-2xl mb-3" aria-hidden>✦</span>
      <p className="font-[600] text-[var(--color-near-black)] text-[15px] mb-1">{title}</p>
      <p className="text-[var(--color-mid-gray)] text-[14px] leading-relaxed max-w-xs">{body}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function InternErrorState({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="rounded-[4px] border border-[var(--destructive)]/30 bg-[var(--destructive)]/5 p-6 text-center">
      <p className="text-[var(--destructive)] text-[14px] font-[500] mb-3">
        Couldn't load your day.
      </p>
      <button
        onClick={onRetry}
        className="text-[var(--destructive)] text-[13px] underline underline-offset-2 hover:no-underline"
      >
        Try again
      </button>
    </div>
  );
}
